import { Eye } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, PreviewPdf } from 'core/components';
import { IPartDetails } from 'parts/types';
import { Variant } from 'theme/enums';

interface IProps {
  part?: IPartDetails | null;
}

export const DatasheetPreviewButton = ({ part }: IProps) => {
  const { t } = useTranslation();
  const [isDatasheetPreviewOpen, setIsDatasheetPreviewOpen] = useState(false);

  const datasheetFileName =
    part?.datasheetFileName || t('labelDatasheetDefaultFileName', { part: part?.number });

  if (!part?.datasheetLink) {
    return null;
  }

  return (
    <>
      <Button
        startDecorator={<Eye />}
        variant={Variant.SOFT}
        text={t('buttonLabelPreviewDataSheet')}
        onClick={() => setIsDatasheetPreviewOpen(true)}
      />

      <PreviewPdf
        isOpen={isDatasheetPreviewOpen}
        onClose={() => setIsDatasheetPreviewOpen(false)}
        fileName={datasheetFileName}
        fileUrl={part?.datasheetLink}
      />
    </>
  );
};
